import { useMutation } from '@tanstack/react-query';
import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import { DefaultOptionType } from 'antd/es/select';
import { CustomerApis } from 'apis/CustomerApis';
import axiosGraphQL from 'apis/GraphQL/axiosGraphQL';
import { GET_ALL_PLANT } from 'apis/GraphQL/Queries/plantQuery';
import { FormFilter, InputForm, SelectForm } from 'components';
import LazySelectForm, {
  ILazySelectData,
  ILazySelectParams,
  initLazySelectData,
} from 'components/Select/LazySelectForm';
import { useUser } from 'contexts/UserProvider';
import { IParamQraphQL } from 'interfaces/GraphQL/GraphQL';
import Content from 'layouts/Content';
import React, { useCallback, useEffect, useState } from 'react';
import { TEAM_TYPE_OPTIONS } from 'utils/constants/TeamSale/TeamSale';

interface IProps {
  isOpen: boolean;
  defaultFilter: any;
  onCancel: () => void;
  onFinish: (values: any) => void;
}

const spanCol = 6;
const FilterPaymentSummary = (props: IProps) => {
  const { isOpen, defaultFilter, onCancel, onFinish } = props;
  const { user } = useUser();
  const [form] = useForm();

  const [optionsBranch, setOptionsBranch] = useState<DefaultOptionType[]>([]);
  const [customerData, setCustomersInRoute] =
    useState<ILazySelectData>(initLazySelectData);

  const mutationBranch = useMutation({
    mutationKey: ['getAllBranch'],
    mutationFn: (params: IParamQraphQL) =>
      axiosGraphQL.post('/graphql', params),
    onSuccess: (res) => {
      setOptionsBranch(
        res.data?.getPlant
          ? res.data?.getPlant.items.map((item: any) => ({
              label: item.id,
              value: item.id,
            }))
          : [],
      );
    },
    onError: (error) => {
      console.log(error);
    },
  });

  const { mutate: getCustomersMutate, isPending: isGetCustomersMutatePending } =
    useMutation({
      mutationFn: (params: {
        pageSize: number;
        searchValue: string;
        plantId?: string;
      }) => CustomerApis.getCustomersInCombobox(params),
      onSuccess: (res) => {
        if (res?.data?.getCustomer) {
          const data = res?.data?.getCustomer;

          setCustomersInRoute({
            options: data.items.map(
              (item: any) =>
                ({
                  label:
                    (item?.sapCustomerId ?? 'DMS') +
                    (item?.storeName ? ` - ${item.storeName}` : ''),
                  value: item?.id,
                }) as DefaultOptionType,
            ),
            totalItems: data?.pageInfo?.totalItems,
          });
        }
      },
    });

  useEffect(() => {
    if (user?.isAdmin || user?.isHO) {
      mutationBranch.mutate({
        query: GET_ALL_PLANT,
        variables: {
          input: {
            id: {
              not: '5000',
            },
          },
        },
      });
    }
  }, []);

  useEffect(() => {
    form.setFieldsValue(defaultFilter);
  }, [defaultFilter, form]);

  const handleCancel = () => {
    form.resetFields();
    form.setFieldsValue(defaultFilter);

    onCancel();
  };

  const handleCustomerSelectScrollChange = useCallback(
    (params: ILazySelectParams) => {
      const { pageSize, value } = params;
      const formData = form.getFieldsValue();

      // console.log(formData);

      getCustomersMutate({
        pageSize,
        // plantId: formData?.plantId,
        searchValue: value || '',
      });
    },
    [form],
  );

  const handleTHTTSelectScrollChange = useCallback(
    (params: ILazySelectParams) => {
      const { pageSize, value } = params;
      const formData = form.getFieldsValue();
    },
    [form],
  );

  return (
    <Content isOpen={isOpen}>
      <FormFilter form={form} onFinish={onFinish} onCancel={handleCancel}>
        <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Chi nhánh" name="plantId">
              <SelectForm
                options={optionsBranch}
                disabled={!(user?.isAdmin || user?.isHO)}
                placeholder="Chọn chi nhánh"
                // onChange={handleChangePlant}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Mã THTT" name="id">
              <InputForm
                // loading={getLisRouteCbLoading}
                placeholder="Tìm mã THTT"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Tìm KH" name="customerId">
              <LazySelectForm
                data={customerData}
                loading={isGetCustomersMutatePending}
                placeholder="Tìm MST/Mã khách hàng"
                onSelectScrollChange={handleCustomerSelectScrollChange}
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item
              label="Ngày tạo từ - đến"
              name="fromDateToDate"
              rules={[{ required: true, message: 'Vui lòng chọn ngày' }]}
            >
              <DatePicker.RangePicker
                placeholder={['Từ ngày', 'Đến ngày']}
                format={'DD/MM/YYYY'}
                size="large"
              />
            </Form.Item>
          </Col>
          <Col span={spanCol} className="h-[80px]">
            <Form.Item label="Loại đội" name="statusId">
              <SelectForm
                loading={isGetCustomersMutatePending}
                placeholder="Chọn loại đội"
                filterSort={(optionA: any, optionB: any) => 0}
                options={[
                  ...TEAM_TYPE_OPTIONS,
                  {
                    label: 'Kế toán',
                    value: '',
                  },
                ]}
              />
            </Form.Item>
          </Col>
        </Row>
      </FormFilter>
    </Content>
  );
};

export default FilterPaymentSummary;
